/* cart-fixes.js — прави drawer scrollable и фиксира футъра */
(function(){
  function makeCartScrollable() {
    var drawer = document.querySelector('.cart-drawer, .drawer, .ajaxcart, .side-cart, .cart-popup, .drawer--cart, .ajaxcart__inner');
    var footer = document.querySelector('.cart__footer, .drawer__footer, .ajaxcart__footer, .cart-footer, .cart-actions');
    if (drawer) {
      drawer.style.maxHeight = '100vh';
      drawer.style.overflowY = 'auto';
      drawer.style.webkitOverflowScrolling = 'touch';
    }
    if (footer) {
      footer.style.position = 'sticky';
      footer.style.bottom = '0';
      footer.style.zIndex = '99999';
      footer.style.background = window.getComputedStyle(document.body).backgroundColor || '#fff';
    }
  }

  // Пуска се при всяко кликване (когато отваряш количката)
  document.addEventListener('click', function(e){
    var c = e.target.closest('[data-cart-open], [data-action="open-cart"], .js-drawer-open, .drawer-open, [data-drawer-open]');
    if (c) {
      setTimeout(makeCartScrollable, 60);
    }
  }, true);

  // И при load (в случай че количката е отворена автоматично)
  window.addEventListener('load', function(){ setTimeout(makeCartScrollable, 200); });
})();
